import { User } from "oidc-client-ts";

// TODO - SOC2 VAPT Check
export const TokenService = {
    getCansoToken : () => {
        const saved_session = localStorage.getItem(`oidc.user:${window.IDP_AUTHORITY}:${window.AUTH_CLIENT_ID}`);
        if(!saved_session){
            return null;
        }

        return User.fromStorageString(saved_session).access_token;
    },
}